import t, { forwardRef as S, useRef as N, useCallback as B, useEffect as E } from "react";
import { TypographyComponent as C } from "../typography/typography-component.esm.js";
import "../typography/typography-config.esm.js";
import { useNamedId as L } from "../utils/hooks/useId.esm.js";
const W = "_radio_1pvit_1", A = "_radioFullWidth_1pvit_7", I = "_radioMarginBottom_1pvit_11", k = "_radioMarginRight_1pvit_15", D = "_input_1pvit_19", $ = "_label_1pvit_65", j = "_inputSafariFocus_1pvit_70", w = "_srLabel_1pvit_96", a = {
  radio: W,
  radioFullWidth: A,
  radioMarginBottom: I,
  radioMarginRight: k,
  input: D,
  label: $,
  inputSafariFocus: j,
  srLabel: w
}, x = S(
  ({
    analyticsId: d = void 0,
    className: l = "",
    clickCallback: o = void 0,
    dataTestId: u = "",
    disabled: p = !1,
    fullWidth: f = !1,
    id: _ = void 0,
    marginBottom: c = !1,
    marginRight: m = !1,
    radioLabel: g = "",
    radioName: v = "",
    srLabel: e = "",
    style: b = void 0,
    ...h
  }, M) => {
    const R = L("fuse-radio-input"), r = _ || R, s = N(null), F = B(
      (i) => {
        typeof o == "function" && o(i);
      },
      [o]
    );
    E(() => {
      var n;
      const i = navigator.userAgent;
      /Safari/i.test(i) && !/Chrome/i.test(i) && !/Mobi|Android/i.test(i) && ((n = s.current) == null || n.classList.add(a.inputSafariFocus));
    }, []);
    const y = [
      "fuse-radio",
      a.radio,
      f && a.radioFullWidth,
      c && a.radioMarginBottom,
      m && a.radioMarginRight,
      l
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ t.createElement(
      "div",
      {
        className: y,
        "data-analyticsid": d,
        "data-testid": u || "fuse-radio-test-id",
        ref: M,
        style: b
      },
      /* @__PURE__ */ t.createElement(
        "input",
        {
          className: `${a.input} fuse-radio__input`,
          "data-testid": "fuse-radio__input",
          disabled: p,
          id: r,
          name: v,
          onClick: (i) => F(i),
          ref: s,
          type: "radio",
          ...h
        }
      ),
      /* @__PURE__ */ t.createElement(
        C,
        {
          className: `${a.label} fuse-radio__label`,
          "data-testid": "fuse-radio__label",
          htmlFor: r,
          size: "1",
          tag: "label",
          type: "paragraph",
          disableMargin: !0
        },
        g,
        e && /* @__PURE__ */ t.createElement("span", { className: a.srLabel }, " ", e)
      )
    );
  }
);
x.displayName = "Radio";
export {
  x as Radio
};
